import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip } from '@modusign/design-system';

import CenterLoadingSpinner from '@app/components/CenterLoadingSpinner';

export default function InputSearchButton({
  disabled,
  isLoading,
  onClick,
}: {
  disabled: boolean;
  isLoading: boolean;
  onClick: () => void;
}) {
  return (
    <Tooltip content="주소록 검색" placement="top-end">
      <Box
        aria-label="주소록 검색"
        as="button"
        bg="buttonBackgroundNeutralBase"
        borderRadius="0px 2px 2px 0px"
        className="tagAddressSearchButton"
        color="iconNeutralSlightlyDark"
        disabled={disabled}
        height={'calc(100% - 2px)'}
        px={4}
        py="10px"
        sx={{
          '&:hover': { bg: 'buttonBackgroundNeutralSlightlyDark' },
        }}
        type="button"
        onClick={onClick}
      >
        {isLoading ? (
          <Box as="span" display="inline-block" height="100%" position="relative" width="14px">
            <CenterLoadingSpinner color="gray" size={18} testId="address-search-loading-spinner" />
          </Box>
        ) : (
          <FontAwesomeIcon icon={faSearch} />
        )}
      </Box>
    </Tooltip>
  );
}
